export default "__VITE_ASSET__BguWPV6y__"